import { lazy } from "react";
import LowPriorityIcon from "@mui/icons-material/LowPriority";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Navigate } from "react-router-dom";

const LocationList = lazy(() => import("../components/locationList"));

const locationRoute = {
  icon: LocationOnIcon,
  name: "Location Management",
  link: "/location-management",
  path: "location-management",
  index: 15,
  element: "",
  superAdminView: false,
  children: [
    {
      path: "employee-sequencing",
      element: <LocationList />,
      permission: "Zone-Read",
      name: "Employee Sequencing",
      index: 4,
      link: "location-management/employee-sequencing",
      icon: LowPriorityIcon,
    },
    {
      path: "",
      element: <Navigate to="employee-sequencing" replace />,
    },
  ],
};
export default locationRoute;
